/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Field_NameInputs */



/**
* | output |
* | --- |
* | "Full name (your signature)" |
*
* @param {Nda_Field_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_field_name = /** @type {((inputs?: Nda_Field_NameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Field_NameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom complet (votre signature)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre completo (su firma)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome completo (sua assinatura)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome completo (la tua firma)")
	return /** @type {LocalizedString} */ ("Full name (your signature)")
});